import React from "react";
import { Card, List } from "../material-old";
import { useLocation } from "react-router-dom";
import { SidebarImage } from "./SidebarImage.tsx";
import { sidebarItems } from "./fixtures/sidebarItems.tsx";
import { SidebarItem } from "./SidebarItem.tsx";
import { useIsMobile } from "../../hooks/useIsMobile.ts";
import { useAppSelector } from "../../redux/hooks.ts";

export default function Sidebar() {
  const { pathname } = useLocation();
  const { isMobile } = useIsMobile();

  const { userInfo } = useAppSelector((state) => state.auth);

  const ParentContainer: React.FC<{ children: React.ReactNode }> = ({
    children,
  }) => {
    if (isMobile) {
      return (
        <div className="flex flex-col justify-center items-center h-screen sticky left-0">
          {children}
        </div>
      );
    }
    return (
      <div className="flex flex-col">
        <div className="flex items-center justify-center px-4">
          <SidebarImage />
        </div>
        <List className="flex flex-col">
          <hr className="my-2 border-blue-gray-50" />
          {children}
        </List>
      </div>
    );
  };

  if (!userInfo) return null;

  return (
    <aside
      className={`${isMobile ? "h-screen" : "fixed top-0 left-0 h-full"} z-10`}
    >
      <Card shadow={false} className="h-full p-4">
        <ParentContainer>
          {sidebarItems.map((item) => (
            <SidebarItem
              key={item.label}
              icon={item.icon}
              label={item.label}
              href={item.href}
              active={
                item.href === "/"
                  ? item.href === pathname
                  : pathname.startsWith(item.href)
              }
              mobile={isMobile}
            />
          ))}
        </ParentContainer>
      </Card>
    </aside>
  );
}
